module.exports = __webpack_public_path__ + "media/checklist.e2e5bfa3.svg";